import { queryClient } from 'providers/queryClient';
import { useDelete } from 'react-admin';
import { DeleteDialog } from 'shared/mui/Dialogs';
import { Typography } from 'shared/mui/Typography';
import { TypographyBold } from 'shared/mui/Typography/TypographyBold';
import { ProviderWhiteIpAddress } from 'types/embedded/provider';

type Props = {
  onClose: VoidFunction;
  open: boolean;
  record?: ProviderWhiteIpAddress;
};

export const ProvidersShowWhiteIpAddressesDeleteDialog: React.FC<Props> = ({
  onClose,
  open,
  record,
}) => {
  const [deleteOne, { isLoading }] = useDelete(
    'provider_white_ip_addresses',
    {
      id: record?.id || '',
    },
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries({ queryKey: ['provider_white_ip_addresses'] });
        onClose();
      },
    },
  );

  return (
    <DeleteDialog
      details={
        <Typography>
          Белый IP <TypographyBold fontSize={16} text={record?.ip || ''} /> для провайдера{' '}
          <TypographyBold fontSize={16} text={record?.provider?.name || ''} /> будет удален без
          возможности восстановления.
        </Typography>
      }
      isLoading={isLoading}
      onClose={onClose}
      onDelete={deleteOne}
      onSuccess={onClose}
      open={open}
      title="Удаление белого IP"
    />
  );
};
